export default __webpack_public_path__ + "static/media/Snd_21.b9fc43d0.mp3";